<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-p4_fordow_crosssection-box">
  <!-- Artboard: xs -->
  <div
    id="g-p4_fordow_crosssection-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.26969988615728;"
  >
    <div
      id="g-p4_fordow_crosssection-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_fordow_crosssection-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:4.8694%;margin-top:-8.6px;left:90.6732%;width:43px;"
    >
      <p class="g-pstyle0">B-2</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs"
      style="top:9.6438%;left:1.8835%;width:35.4545%;"
    >
      <p>
        The GBU‑57 Massive Ordnance Penetrator uses GPS and inertial navigation
        to guide itself accurately to its target before impact.
      </p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:12.0614%;margin-top:-8.6px;left:53.8951%;width:68px;"
    >
      <p class="g-pstyle0">GBU-57</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:34.2912%;margin-top:-8.6px;left:60.4017%;width:70px;"
    >
      <p class="g-pstyle1">GBU-28</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:34.4138%;margin-top:-8.1px;left:80.4413%;width:70px;"
    >
      <p class="g-pstyle2">Blu -109</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.531%;margin-top:-8.6px;left:75.9817%;width:50px;"
    >
      <p class="g-pstyle3">15 m</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs"
      style="top:53.2044%;left:1.8835%;width:35.7576%;"
    >
      <p>
        The weapon is reported to <span class="g-cstyle0"
          >penetrate over 60 meters of rock or concrete,</span
        > although its effectiveness can vary based on terrain composition.
      </p>
    </div>
    <div
      id="g-ai0-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:57.9104%;margin-top:-8.6px;left:62.7383%;width:53px;"
    >
      <p class="g-pstyle3">30 m</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-text g-aiAbs"
      style="top:59.5792%;left:60.0313%;width:35.4545%;"
    >
      <p>
        According to the CSIS, Israel possesses GBU‑28 and BLU‑109
        bunker‑busting bombs with limited penetration.
      </p>
    </div>
    <div
      id="g-ai0-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:78.996%;margin-top:-8.6px;left:43.9278%;width:53px;"
    >
      <p class="g-pstyle3">60 m</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-text g-aiAbs"
      style="top:79.9292%;left:60.0313%;width:35.1515%;"
    >
      <p>
        <span class="g-cstyle0">Multiple GBU‑57 MOPs might be needed</span> in sequence
        to ensure complete destruction of Fordow&rsquo;s subterranean facilities.
      </p>
    </div>
    <div
      id="g-ai0-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:93.0531%;margin-top:-16.6px;left:3.416%;width:150px;"
    >
      <p class="g-pstyle4">Fordow underground</p>
      <p class="g-pstyle4">nuclear facility</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:97.3029%;margin-top:-8.6px;left:67.7137%;width:81px;"
    >
      <p class="g-pstyle4">80-100 m</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-p4_fordow_crosssection-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.41463414634146;"
  >
    <div
      id="g-p4_fordow_crosssection-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_fordow_crosssection-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:4.197%;margin-top:-8.6px;left:92.0805%;width:44px;"
    >
      <p class="g-pstyle0">B-2</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs"
      style="top:7.6423%;left:5.0321%;width:29.8039%;"
    >
      <p>
        The GBU‑57 Massive Ordnance Penetrator uses GPS and inertial navigation
        to guide itself accurately to its target before impact.
      </p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:9.888%;margin-top:-8.6px;left:51.8911%;width:72px;"
    >
      <p class="g-pstyle0">GBU-57</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:32.0018%;margin-top:-8.6px;left:56.1012%;width:73px;"
    >
      <p class="g-pstyle1">GBU-28</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:32.1644%;margin-top:-8.6px;left:69.0681%;width:74px;"
    >
      <p class="g-pstyle1">Blu -109</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1726%;margin-top:-8.6px;left:66.1826%;width:52px;"
    >
      <p class="g-pstyle2">15 m</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-text g-aiAbs"
      style="top:53.4146%;left:5.0321%;width:32.1569%;"
    >
      <p>
        The weapon is reported to <span class="g-cstyle0"
          >penetrate over 60 meters of rock or concrete,</span
        > although its effectiveness can vary based on terrain composition.
      </p>
    </div>
    <div
      id="g-ai1-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.4978%;margin-top:-8.6px;left:57.6132%;width:55px;"
    >
      <p class="g-pstyle2">30 m</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-text g-aiAbs"
      style="top:56.8293%;left:58.0148%;width:31.5686%;"
    >
      <p>
        According to the Center for Strategic and International Studies<span
          class="g-cstyle0"
          >,
        </span>
        Israel possesses GBU‑28 and BLU‑109 bunker‑busting bombs with limited penetration<span
          class="g-cstyle0">.</span
        >
      </p>
    </div>
    <div
      id="g-ai1-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.4734%;margin-top:-8.6px;left:45.4416%;width:56px;"
    >
      <p class="g-pstyle2">60 m</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-text g-aiAbs"
      style="top:79.2683%;left:58.0148%;width:32.3529%;"
    >
      <p>
        <span class="g-cstyle0">Multiple GBU‑57 MOPs might be needed</span> in sequence
        to ensure complete destruction of Fordow&rsquo;s subterranean facilities.
      </p>
    </div>
    <div
      id="g-ai1-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:90.6197%;margin-top:-16.6px;left:5.3039%;width:159px;"
    >
      <p class="g-pstyle3">Fordow underground</p>
      <p class="g-pstyle3">nuclear facility</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:94.6848%;margin-top:-8.6px;left:60.8326%;width:85px;"
    >
      <p class="g-pstyle3">80-100 m</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-p4_fordow_crosssection-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.53658536585366;"
  >
    <div
      id="g-p4_fordow_crosssection-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_fordow_crosssection-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:4.197%;margin-top:-9.6px;left:94.6622%;width:44px;"
    >
      <p class="g-pstyle0">B-2</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs"
      style="top:7.6423%;left:27.3974%;width:23.0303%;"
    >
      <p>
        The GBU‑57 Massive Ordnance Penetrator uses GPS and inertial navigation
        to guide itself accurately to its target before impact.
      </p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:9.888%;margin-top:-9.6px;left:63.6068%;width:72px;"
    >
      <p class="g-pstyle0">GBU-57</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:32.0831%;margin-top:-9.6px;left:66.8599%;width:73px;"
    >
      <p class="g-pstyle1">GBU-28</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:32.1644%;margin-top:-9.6px;left:76.8799%;width:74px;"
    >
      <p class="g-pstyle1">Blu -109</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1353%;margin-top:-10.2px;left:74.6501%;width:54px;"
    >
      <p class="g-pstyle2">15 m</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs"
      style="top:53.4146%;left:27.3974%;width:24.8485%;"
    >
      <p>
        The weapon is reported to <span class="g-cstyle0"
          >penetrate over 60 meters of rock or concrete,</span
        > although its effectiveness can vary based on terrain composition.
      </p>
    </div>
    <div
      id="g-ai2-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.5418%;margin-top:-10.2px;left:68.0282%;width:57px;"
    >
      <p class="g-pstyle2">30 m</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-text g-aiAbs"
      style="top:56.8293%;left:68.3386%;width:24.3939%;"
    >
      <p>
        According to the Center for Strategic and International Studies<span
          class="g-cstyle0"
          >,
        </span>
        Israel possesses GBU‑28 and BLU‑109 bunker‑busting bombs with limited penetration<span
          class="g-cstyle0">.</span
        >
      </p>
    </div>
    <div
      id="g-ai2-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.4361%;margin-top:-10.2px;left:58.623%;width:58px;"
    >
      <p class="g-pstyle2">60 m</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-text g-aiAbs"
      style="top:79.2683%;left:68.3386%;width:25%;"
    >
      <p>
        <span class="g-cstyle0">Multiple GBU‑57 MOPs might be needed</span> in sequence
        to ensure complete destruction of Fordow&rsquo;s subterranean facilities.
      </p>
    </div>
    <div
      id="g-ai2-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:89.8168%;margin-top:-20.7px;left:21.2828%;width:187px;"
    >
      <p class="g-pstyle3">Fordow underground</p>
      <p class="g-pstyle3">nuclear facility</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:94.7288%;margin-top:-10.2px;left:70.5161%;width:89px;"
    >
      <p class="g-pstyle4">80-100 m</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2025-06-20 15:32 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-20 15:32 -->
<!-- ai file: p4_fordow_crosssection.ai -->
<style lang="scss">
  #g-p4_fordow_crosssection-box,
  #g-p4_fordow_crosssection-box .g-artboard {
    margin: 0 auto;
  }
  #g-p4_fordow_crosssection-box p {
    margin: 0;
  }
  #g-p4_fordow_crosssection-box .g-aiAbs {
    position: absolute;
  }
  #g-p4_fordow_crosssection-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-p4_fordow_crosssection-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-p4_fordow_crosssection-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-p4_fordow_crosssection-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-p4_fordow_crosssection-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) {
      #g-p4_fordow_crosssection-md {
        display: block !important;
      }
    }
  }
  #g-p4_fordow_crosssection-xs {
    position: relative;
    overflow: hidden;
  }
  #g-p4_fordow_crosssection-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 16px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p4_fordow_crosssection-xs .g-pstyle0 {
    height: 16px;
    color: rgb(121, 121, 121);
  }
  #g-p4_fordow_crosssection-xs .g-pstyle1 {
    height: 16px;
  }
  #g-p4_fordow_crosssection-xs .g-pstyle2 {
    line-height: 15px;
    height: 15px;
  }
  #g-p4_fordow_crosssection-xs .g-pstyle3 {
    font-weight: 700;
    height: 16px;
    color: rgb(0, 0, 0);
  }
  #g-p4_fordow_crosssection-xs .g-pstyle4 {
    font-weight: 700;
    height: 16px;
    color: rgb(165, 15, 21);
  }
  #g-p4_fordow_crosssection-xs .g-cstyle0 {
    font-weight: 700;
  }
  #g-p4_fordow_crosssection-sm {
    position: relative;
    overflow: hidden;
  }
  #g-p4_fordow_crosssection-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 16px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p4_fordow_crosssection-sm .g-pstyle0 {
    height: 16px;
    color: rgb(121, 121, 121);
  }
  #g-p4_fordow_crosssection-sm .g-pstyle1 {
    height: 16px;
  }
  #g-p4_fordow_crosssection-sm .g-pstyle2 {
    font-weight: 700;
    height: 16px;
    color: rgb(0, 0, 0);
  }
  #g-p4_fordow_crosssection-sm .g-pstyle3 {
    font-weight: 700;
    height: 16px;
    color: rgb(165, 15, 21);
  }
  #g-p4_fordow_crosssection-sm .g-cstyle0 {
    font-weight: 700;
  }
  #g-p4_fordow_crosssection-md {
    position: relative;
    overflow: hidden;
  }
  #g-p4_fordow_crosssection-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p4_fordow_crosssection-md .g-pstyle0 {
    height: 18px;
    font-size: 15px;
    color: rgb(121, 121, 121);
  }
  #g-p4_fordow_crosssection-md .g-pstyle1 {
    height: 18px;
    font-size: 15px;
  }
  #g-p4_fordow_crosssection-md .g-pstyle2 {
    font-weight: 700;
    line-height: 19px;
    height: 19px;
    color: rgb(0, 0, 0);
  }
  #g-p4_fordow_crosssection-md .g-pstyle3 {
    font-weight: 700;
    line-height: 20px;
    height: 20px;
    font-size: 18px;
    color: rgb(165, 15, 21);
  }
  #g-p4_fordow_crosssection-md .g-pstyle4 {
    font-weight: 700;
    line-height: 19px;
    height: 19px;
    color: rgb(165, 15, 21);
  }
  #g-p4_fordow_crosssection-md .g-cstyle0 {
    font-weight: 700;
  }

  /* Custom CSS */
  .g-shadow {
    text-shadow:
      1px 1px 1px rgb(0 0 0 / 90%),
      1px -1px 1px rgb(0 0 0 / 90%),
      -1px 1px 1px rgb(0 0 0 / 90%),
      -1px -1px 1px rgb(0 0 0 / 90%);
  }
</style>
